import api from '../api';
import { TrainingCategoryResponse, TypeTraining } from '../models';

export class TrainingService {
  public show = (id: number) => api.get<TypeTraining>(`/pwa/training/${id}`);

  public getTrainings = () => api.get<TypeTraining[]>('/pwa/training');

  public getTrainingByCategory = () =>
    api.get<TrainingCategoryResponse[]>('/pwa/category/training');

  public setViewedTraining = (training_id: number) =>
    api.post('/pwa/training/viewed', { trainingId: training_id });
}

const trainingService = new TrainingService();
export default trainingService;
